import * as React from 'react'

import { Icon } from '@/component/atoms/Icon'
import { openOnlineOnboardingLink } from '@/utils/openOnlineOnboardingLink'
import { mixpanelClient } from '@/utils/trackings/mixpanel'

import S from './AcademyNavLink.style'

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'type'>

function AcademyNavLink(props: Props) {
  const handleClick = () => {
    mixpanelClient.track('GNB_아카데미_click')
    openOnlineOnboardingLink()
  }

  return (
    <button type="button" css={S.link} onClick={handleClick} {...props}>
      아카데미
      <Icon name="go_to_link" size={18} css={S.arrow} className="academy-link-arrow" aria-hidden />
    </button>
  )
}

export default AcademyNavLink
